import { useEffect, useState } from "react";

//api
import { listMyPasskeys } from  "@/api/orgSettings/passkeys";

//services
import { GrantTypeService } from "@/services/grantType.service";

export const usePasskeySetupNeeded = () => {

    const [userHasPasskeyButIsntUsingIt, setUserHasPasskeyButIsntUsingIt] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        if(!GrantTypeService.isMfaSession) {
            checkIfUserHasPasskeys();
        }
        else {
            setIsLoading(false)
        }
    },[]);

    async function checkIfUserHasPasskeys(){
        try {
            const {totalItemCount} = await listMyPasskeys()
            setUserHasPasskeyButIsntUsingIt(!GrantTypeService.isMfaSession && totalItemCount > 0)
        }
        catch {
            setUserHasPasskeyButIsntUsingIt(false);
        }
        finally {
            setIsLoading(false)
        }
    }

    function getBuuttonText(serHasPasskeyButIsntUsingIt: boolean) {
        return serHasPasskeyButIsntUsingIt
            ? 'Login with your Passkey'
            : 'Create a Passkey'
    }

    return { userHasPasskeyButIsntUsingIt, isLoading, getBuuttonText, isSingleFactorExternal: GrantTypeService.isSingleFactorExternal() }
}